import React from 'react';
import tw from 'twin.macro';
import { css } from '@emotion/react';

import { SavedReplyFragment } from '$/GraphQL/schema/types';

import Button from '$/components/ui/Button';

import { EditIcon } from '$/images/Icons';
import { DeleteIcon } from '$/images/FontAwesomeIcons';

import { useSavedRepliesContext } from '../SavedRepliesContext';

export const SavedReplyButtons: React.FC<{
  savedReply: SavedReplyFragment;
  className?: string;
}> = ({ savedReply, className }) => {
  const { onEdit, onDelete } = useSavedRepliesContext();

  const onEditClick = React.useCallback(
    (e: React.MouseEvent): void => {
      e.stopPropagation();
      onEdit(savedReply.id);
    },
    [onEdit, savedReply.id]
  );

  const onDeleteClick = React.useCallback(
    (e: React.MouseEvent): void => {
      e.stopPropagation();
      onDelete(savedReply.id);
    },
    [onDelete, savedReply.id]
  );

  return (
    <div
      className={className}
      css={css`
        ${tw`flex items-center`}
      `}
    >
      <Button.row onClick={onEditClick}>
        <EditIcon
          className='w-1e'
          css={css`
            height: 1.3rem !important;
          `}
        />
      </Button.row>

      <Button.row className='ml-1/2e' onClick={onDeleteClick}>
        <DeleteIcon className='w-1e h-1e text-coral-1' />
      </Button.row>
    </div>
  );
};
